import { Text, View } from '@rbilabs/universal-components';

export const PriceAndCaloriesWrapper = View.withConfig({
  flexDirection: 'row',
  alignItems: 'center',
  flexWrap: 'nowrap',
});

export const CaloriesText = Text.withConfig({
  variant: 'copyTwo',
  marginRight: 2,
});

export const Price = Text.withConfig({
  variant: 'copyTwo',
  fontWeight: 'bold',
});
